import { css } from 'lit';
export const passwordStyles = css `
    .hlx-progress {
        display: flex;
        align-items: center;
        margin-top: var(--hlx-spacing-lg);
    }

    .hlx-progress-quality {
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-semibold);
        margin-right: 25px;
        white-space: nowrap;
    }

    .hlx-progress-quality-description {
        margin-bottom: var(--hlx-spacing-xs);
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-medium);
    }

    .hlx-progress-inner {
        height: 8px;
        border-radius: 20px;
    }

    .hlx-progress-outer {
        width: 100%;
        height: 8px;
        background-color: #d3d3d3;
        border-radius: 20px;
    }

    .hlx-password-checklist {
        display: block;
        margin-top: var(--hlx-spacing-lg);
    }

    .hlx-input-icon {
        display: inline-flex;
        align-self: center;
        cursor: pointer;
        color: var(--hlx-button-color-tertiary-brand-default);
    }

    .hlx-icon-wrapper {
        display: flex;
        gap: var(--hlx-spacing-xs);
        margin-right: var(--hlx-spacing-md);
    }
`;
//# sourceMappingURL=password.styles.js.map